import { GatewayDto, NodoDto, useGetAziende, useGetListaGateway } from "@/api";
import { FocusEventHandler, forwardRef } from "react";
import { AsyncAutocomplete } from "../../elements/Autocomplete";

const GatewayPicker = forwardRef(
  (
    {
      value: _value,
      onChange,
      onBlur,
      name,
      placeholder,
      size,
      disabled = false,
    }: {
      value:  number | null;
      onChange?: (gatewayId: number | null, aziendaId: number | null) => void;
      onBlur?: FocusEventHandler;
      name?: string;
      placeholder?: string;
      size?: "small" | "medium";
      disabled?: boolean;
    },
    ref
  ) => {
    const { data: gateways } = useGetListaGateway();

    const value =
      _value && gateways?.data
        ? gateways.data.find((x) => x.id === _value)
        : null;

    return (
      <>
        <AsyncAutocomplete<GatewayDto>
          ref={ref}
          onChange={(e, x) => {
            console.log("change", e, x);
            if (x) {
              onChange?.(x.id, x.azienda.id);
            } else {
              onChange?.(null, null);
            }
          }}
          fetchOptions={useGetListaGateway}
          getOptionLabel={(gateway) => gateway.nome}
          value={value}
          onBlur={onBlur}
          name={name}
          placeholder={placeholder}
          size={size}
          disabled={disabled}
        />
      </>
    );
  }
);

export default GatewayPicker;
